// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__29pyv","imageUploader":"EGiftCard_imageUploader__1S9vH"};